import type { SxProps, Theme } from '@mui/material';

export const readingControlsStatusBoxSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexWrap: 'wrap',
};
